import { loadLogger } from 'lib/dynamicModules';

export const getPaymentLogger = async () => {
  const logger = await loadLogger();

  const paymentLogger = logger.child({ event: { tag: 'payment' } });

  return paymentLogger;
};
